
import { EditOutlined } from '@mui/icons-material';
export const settingOptions = [
  { id: 1, label: "One way trip",value:'One way trip' },
  { id: 2, label: "Out Station",value:'Out Station' },
  { id: 3, label: "Two way Trip",value:'Two way Trip' },
];


export const SettingService=[
  { id:1, title:'Rental Ride', count:'721'},
  { id:2, title:'Round Trip', count:'121'},
  { id:3, title:'Oneway Trip', count:'150'},
  { id:4, title:'Daily Ride', count:'322'},
]


export const updatedSettingsForm = (details) => [
  {
    id:'1',
    placeholder: "Mobile Number",
    type: "text",
    max: 10,
    name: "number",
    label: "Mobile Number",
    countrycode: true,
    icon: <EditOutlined />,
    editProps: true,
    disabled: true,
    verifyButton: "verifyButton",
    cancelButton: "cancelButton",
    defaultValue: details?.mobile?.replaceAll("+91","") || ""
  },
  {
    id:'2',
    placeholder: "Email",
    type: "text",
    name: "email",
    label: "Email",
    icon: <EditOutlined />,
    editProps: true,
    disabled: true,
    verifyButton: "verifyButton",
    cancelButton: "cancelButton",
    defaultValue: details?.email || ""
  },
];

export const updatedSettingsForm2 =  [
  {
    id:'1',
    placeholder: "Mobile Number",
    type: "text",
    max: 10,
    name: "number",
    label: "Mobile Number",
    // countrycode: true,
    icon: <EditOutlined />,
    editProps: true,
    disabled: true,
    verifyButton: "verifyButton",
    cancelButton: "cancelButton"
  }
];

export const updatedSettingsForm3 =  [
  {
    id:'2',
    placeholder: "Email ID",
    type: "text",
    name: "email",
    label: "Email ID",
    icon: <EditOutlined />,
    editProps: true,
    disabled: true,
    verifyButton: "verifyButton",
    cancelButton: "cancelButton"
  },
];